module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/coj_d-5-5c191838adb8a953bf6851fc8202f10d.jpg";